// Freeplay (freeplays.site) seam — the arcade's SDK (/sdk/v1.js, a postMessage bridge) is on the page only in the
// Freeplay build (tools/fp_publish.sh adds the tag). Everywhere else every call here is a no-op.
// Same shape as WOBBLE LEAGUE's: the arcade's account name, its play counter, its room codes and invites.

let fp: any = null;
async function boot() {
  const F = (window as any).Freeplay; if (!F) return;
  try { const s = await F.init(); fp = s?.hosted ? s : null; } catch { fp = null; }
}
export const ready: Promise<void> = boot();
export const hosted = () => !!fp;

/** the arcade account's name, or null (guest / not on Freeplay) */
export const username = (): string | null => { const n = fp?.user?.name; return typeof n === "string" && n ? n.slice(0, 20) : null; };

let started = false;
/** the arcade's play counter: once per session, when the first round begins */
export function gameplayStart() { if (fp && !started) { started = true; try { fp.gameplayStart?.(); } catch {} } }

/** the code a friend's arcade invite points at, or "" */
export const joining = (): string => { try { const c = fp?.room?.joining?.(); return typeof c === "string" && /^[A-Za-z0-9]{4,8}$/.test(c) ? c.toUpperCase() : ""; } catch { return ""; } };
export function onJoin(f: (code: string) => void) { try { fp?.onJoin?.((c: string) => { if (c) f(String(c).toUpperCase()); }); } catch {} }
/** we sit at a table: register it with the arcade so its invite link points here */
export function roomJoined(code: string) { if (!fp || !code) return; try { fp.room?.create?.(code)?.catch?.(() => {}); } catch {} }
